import React from 'react';
import ProgramManager from '../../ProgramManager';

export default function AdminSOSearch() {
  // Use ProgramManager with admin mode for full functionality
  // Admin users get full read/write access with all features enabled
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold">SO Search & Management</h2>
        <p className="text-gray-600 mt-1">Search for existing Scheduled Offerings and manage their details</p>
      </div>
      <ProgramManager 
        readOnly={false}  // Admin has full write access
        hideNavButtons={true}  // Hide main nav buttons in admin context
        adminMode={true}  // Enable admin-specific features
      />
    </div>
  );
}